import { colors, gridSize } from '@atlaskit/theme';
import styled from 'styled-components';

import { onSmallDesktopDown } from '../../mobile/responsive';

const gridSizeResult = gridSize();

const SkeletonHome = styled.div`
  background-color: ${colors.N20};
  width: 160px;
  height: ${gridSizeResult * 3}px;
  ${onSmallDesktopDown(`
    width: ${gridSizeResult * 3}px;
    border-radius: 50%;
  `)}
`;

export default SkeletonHome;
